export default __webpack_public_path__ + "static/2-297fbd91a821874d76f2b62564fdafd6.jpeg";